<template>
  <div class="start-work-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <div class="state-sidebar">
          <ul class="state-list">
            <li
              v-for="(item, index) in states"
              :key="index"
              class="state-item"
              :class="{ 'active-state': conditions.state === item.state }"
              @click="switchWorkState(item)"
            >
              {{
                $t(`startWork.state.${item.state === "" ? "ALL" : item.state}`)
              }}
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="20">
        <el-card class="search-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t("startWork.search.title") }}</span>
          </div>

          <!-- 搜索栏：修复级联选择器样式和数据展示 -->
          <el-form :model="conditions" class="search-form" label-width="80px">
            <!-- 第一行：任务名称、任务状态、任务类型、处理人 -->
            <el-row :gutter="15" style="margin-bottom: 10px">
              <el-col :span="6">
                <el-form-item label="任务名称">
                  <el-input
                    v-model="conditions.workName"
                    placeholder="请输入"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务状态">
                  <el-select
                    v-model="conditions.state"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="全部" value="" />
                    <el-option label="草稿" value="T" />
                    <el-option label="待处理" value="W" />
                    <el-option label="处理完成" value="C" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务类型">
                  <!-- 修复级联选择器配置：解决展示异常问题 -->
                  <el-cascader
                    v-model="conditions.wtIds"
                    :options="cascaderWorkTypes"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                    :props="{
                      value: 'wtId',
                      label: 'typeName',
                      children: 'children',
                      checkStrictly: true,
                      expandTrigger: 'click',
                    }"
                    @change="handleWorkTypeChange"
                    popper-class="work-type-cascader"
                    :popper-append-to-body="true"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="处理人">
                  <el-input
                    v-model="conditions.staffName"
                    placeholder="请输入"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行：园区、部门、发起人（预留一列保持布局对称） -->
            <el-row :gutter="15" style="margin-bottom: 10px">
              <el-col :span="6">
                <el-form-item label="所属园区">
                  <el-select
                    v-model="conditions.communityId"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                    filterable
                    remote
                    :remote-method="getParkList"
                    :loading="parkLoading"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="park in parkList"
                      :key="park.communityId"
                      :label="park.name"
                      :value="park.communityId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属部门">
                  <el-select
                    v-model="conditions.deptId"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                    filterable
                    :loading="deptLoading"
                    @change="handleDeptChange"
                  >
                    <el-option
                      v-for="dept in deptList"
                      :key="dept.deptId"
                      :label="dept.deptName"
                      :value="dept.deptId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发起人">
                  <el-select
                    v-model="conditions.createUserId"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                    filterable
                    :loading="userLoading"
                    :disabled="!conditions.deptId"
                  >
                    <el-option
                      v-for="user in creatorList"
                      :key="user.userId"
                      :label="user.userName"
                      :value="user.userId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="紧急程度">
                  <el-select
                    v-model="conditions.urgencyLevel"
                    placeholder="请选择"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="重点" value="1001" />
                    <el-option label="紧急" value="1002" />
                    <el-option label="普通" value="1003" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第三行：开始时间、结束时间、搜索/重置按钮 -->
            <el-row :gutter="15">
              <el-col :span="6">
                <el-form-item label="开始时间">
                  <el-date-picker
                    v-model="conditions.queryStartTime"
                    type="date"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="结束时间">
                  <el-date-picker
                    v-model="conditions.queryEndTime"
                    type="date"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd"
                    :picker-options="endDateOptions"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex align-center justify-end pt10">
                <el-button
                  type="primary"
                  @click="handleSearch"
                  style="margin-right: 10px"
                >
                  {{ $t("common.search") }}
                </el-button>
                <el-button @click="handleReset">
                  {{ $t("common.reset") }}
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <!-- 工单列表：表格单元格设置默认宽度 -->
        <el-card class="work-list-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t("startWork.list.title") }}</span>
            <el-button type="primary" size="small" @click="handleAdd">
              <i class="el-icon-plus" />
              {{ $t("startWork.list.draft") }}
            </el-button>
          </div>
          <el-table
            v-loading="loading"
            :data="works"
            border
            style="width: 100%"
            :default-width="120"
          >
            <el-table-column
              prop="workId"
              :label="$t('startWork.table.workId')"
              align="center"
            />
            <el-table-column
              prop="workName"
              :label="$t('startWork.table.workName')"
              align="center"
              min-width="150"
            />

            <el-table-column
              prop="typeName"
              :label="$t('startWork.table.typeName')"
              align="center"
            />
            <el-table-column
              label="紧急程度"
              prop="urgencyLevel"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  v-if="getUrgencyText(scope.row.urgencyLevel)"
                  :type="getUrgencyTagType(scope.row.urgencyLevel)"
                  size="small"
                >
                  {{ getUrgencyText(scope.row.urgencyLevel) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="内容" align="center" min-width="200">
              <template slot-scope="scope">
                <div
                  class="text-ellipsis"
                  :title="
                    getJoinContentsWithIndex(scope.row.contents) || '无内容'
                  "
                >
                  {{ getJoinContentsWithIndex(scope.row.contents) || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('startWork.table.workCycle')"
              align="center"
            />
            <el-table-column
              prop="createUserName"
              :label="$t('startWork.table.createUser')"
              align="center"
            />
            <el-table-column
              prop="curStaffName"
              :label="$t('startWork.table.handler')"
              align="center"
            />
            <el-table-column
              prop="curCopyName"
              :label="$t('startWork.table.ccUser')"
              align="center"
            />
            <el-table-column
              prop="stateName"
              :label="$t('startWork.table.state')"
              align="center"
            />
            <el-table-column
              prop="createTime"
              :label="$t('startWork.table.createTime')"
              align="center"
              min-width="180"
            />
            <el-table-column
              :label="$t('common.operation')"
              align="center"
              min-width="300"
            >
              <template slot-scope="scope">
                <el-button size="mini" @click="handleDetail(scope.row)">
                  {{ $t("common.detail") }}
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                  style="margin-right: 5px"
                >
                  {{ $t("common.edit") }}
                </el-button>
                <el-button
                  v-if="scope.row.state !== 'C'"
                  size="mini"
                  type="success"
                  @click="handleComplete(scope.row)"
                  style="margin-right: 5px"
                >
                  完成
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  {{ $t("common.delete") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            style="margin-top: 20px; text-align: right"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-work ref="deleteWork" @success="fetchData" />
  </div>
</template>

<script>
import { queryStartWork, updateWorkState } from "@/api/oa/startWorkApi";
import { listWorkType } from "@/api/oa/editWorkApi";
import { listCommunitys } from "@/api/community/communityApi";
import { listOrgTree } from "@/api/work/repairTypeUserApi";
import { getStaffInfos } from "@/api/work/repairTypeUserApi";
import DeleteWork from "@/components/oa/deleteWork";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "StartWorkList",
  components: {
    DeleteWork,
  },
  data() {
    return {
      loading: false,
      communityId: "", // 默认园区ID
      // 园区相关数据和加载状态
      parkLoading: false,
      parkList: [],
      parkPage: {
        current: 1,
        size: 100,
        total: 0,
      },
      // 组织树 + 部门 + 发起人相关数据
      orgs: [], // 组织树原始数据
      deptLoading: false, // 部门加载状态
      deptList: [], // 提取后的部门列表（包含最外层根节点）
      userLoading: false, // 发起人加载状态
      creatorList: [], // 提取后的发起人列表
      // 任务类型相关 - 修复级联数据结构
      workTypes: [],
      cascaderWorkTypes: [], // 适配级联选择器的任务类型数据
      states: [
        { name: "全部", state: "" },
        { name: "草稿", state: "T" },
        { name: "待处理", state: "W" },
        { name: "处理完成", state: "C" },
      ],
      works: [],
      conditions: {
        state: "",
        communityId: "",
        deptId: "",
        createUserId: "",
        workName: "",
        staffName: "",
        wtIds: [], // 级联选择的ID数组
        wtId: "", // 实际查询用的ID
        queryStartTime: "",
        queryEndTime: "",
        urgencyLevel: "",
      },
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      endDateOptions: {
        disabledDate: (time) => {
          if (this.conditions.queryStartTime) {
            return (
              time.getTime() <
              new Date(this.conditions.queryStartTime).setHours(0, 0, 0, 0)
            );
          }
          return false;
        },
      },
    };
  },
  created() {
    this.communityId = getCommunityId();
    this._listWorkTypes();
    this.getParkList();
    this.getDeptList();
    this.fetchData();
  },
  methods: {
    // 原有：获取园区列表
    async getParkList(query = "") {
      this.parkLoading = true;
      try {
        const params = {
          page: this.parkPage.current,
          row: this.parkPage.size,
          storeName: query,
        };
        const res = await listCommunitys(params);
        this.parkList = res.data || [];
        this.parkPage.total = res.total || 0;
      } catch (error) {
        console.error("获取园区列表失败:", error);
        this.$message.warning("获取园区列表失败");
      } finally {
        this.parkLoading = false;
      }
    },

    // 适配真实组织树接口
    async refreshTree() {
      try {
        this.deptLoading = true;
        let communityId = this.conditions.communityId || this.communityId;

        const params = {
          communityId: communityId,
        };
        const response = await listOrgTree(params);
        if (response.code === 0) {
          this.orgs = [response.data];
          this.deptList = this.extractDeptListFromOrgTree(this.orgs);
        } else {
          this.$message.error(
            response.msg || this.$t("暂时无法查询非当前账号园区"),
          );
        }
      } catch (error) {
        console.error("Error loading org tree:", error);
        this.$message.error(this.$t("暂时无法查询非当前账号园区"));
      } finally {
        this.deptLoading = false;
      }
    },

    // 提取部门列表
    extractDeptListFromOrgTree(orgTree) {
      let deptList = [];
      if (!orgTree || !Array.isArray(orgTree)) return deptList;

      orgTree.forEach((node) => {
        if (node.id) {
          deptList.push({
            deptId: node.id,
            deptName: node.text,
            allOrgName: node.allOrgName,
          });
        }

        if (node.children && node.children.length > 0) {
          const childDepts = this.extractDeptListFromOrgTree(node.children);
          deptList = [...deptList, ...childDepts];
        }
      });

      return deptList;
    },

    // 加载部门人员
    async loadStaff(orgId) {
      if (!orgId) {
        this.creatorList = [];
        return;
      }
      this.userLoading = true;
      try {
        const params = {
          orgId: orgId,
          row: 50,
          page: 1,
        };
        const response = await getStaffInfos(params);
        const staffs = response.staffs || [];
        this.creatorList = staffs.map((staff) => ({
          userId: staff.userId,
          userName: staff.userName,
          realName: staff.name,
        }));
      } catch (error) {
        console.error("Error loading staff:", error);
        this.$message.error(this.$t("暂时无法查询非当前账号园区"));
        this.creatorList = [];
      } finally {
        this.userLoading = false;
      }
    },

    // 获取部门列表
    async getDeptList() {
      await this.refreshTree();
    },

    // 部门变更事件
    handleDeptChange(deptId) {
      this.conditions.createUserId = "";
      this.loadStaff(deptId);
    },

    // 园区变更事件
    handleCommunityChange() {
      this.conditions.deptId = "";
      this.conditions.createUserId = "";
      this.creatorList = [];
      this.getDeptList();
    },

    // 修复：获取工作类型列表（适配真实数据格式）
    async _listWorkTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId,
        };
        const res = await listWorkType(params);
        this.workTypes = res.data || [];

        // 修复：简化转换逻辑，适配平级数据（如果你的数据没有层级，直接作为一级选项）
        // 如果实际有层级，替换为你的真实层级字段（比如 level / parentId）
        this.cascaderWorkTypes = this.workTypes.map((item) => ({
          wtId: item.wtId,
          typeName: item.typeName,
          // 关键修复：如果没有子节点，设置为空数组（避免显示"暂无数据"）
          children: item.children || [],
        }));

        // 调试：打印数据结构，方便你排查
        console.log("任务类型原始数据:", this.workTypes);
        console.log("级联适配后数据:", this.cascaderWorkTypes);
      } catch (error) {
        console.error("获取工作单类型失败:", error);
        this.$message.warning("获取工作单类型失败");
      }
    },

    // 修复：级联选择器变更事件（兼容单级选择）
    handleWorkTypeChange(value) {
      console.log("级联选择值:", value); // 调试用
      // 无论选择几级，都取最后一个ID作为查询条件
      this.conditions.wtId =
        value && value.length > 0 ? value[value.length - 1] : "";
    },

    // 查询工单列表
    async fetchData() {
      this.loading = true;
      try {
        const useCommunityId = this.conditions.communityId || this.communityId;

        const params = {
          workName: this.conditions.workName,
          staffName: this.conditions.staffName,
          wtId: this.conditions.wtId,
          queryStartTime: this.conditions.queryStartTime,
          queryEndTime: this.conditions.queryEndTime,
          page: this.page.current,
          row: this.page.size,
          communityId: useCommunityId,
          deptId: this.conditions.deptId,
          createUserId: this.conditions.createUserId,
          urgencyLevel: this.conditions.urgencyLevel,
        };
        if (this.conditions.state) {
          params.state = this.conditions.state;
        }

        const { data, total } = await queryStartWork(params);
        this.works = data || [];
        this.page.total = total || 0;
      } catch (error) {
        console.error("获取工单列表失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 内容拼接方法
    getJoinContentsWithIndex(contents) {
      if (!contents || !Array.isArray(contents) || contents.length === 0) {
        return "";
      }
      const contentItems = contents
        .map((item, index) => {
          const content = item.content || "";
          return content ? `内容${index + 1}：${content}` : "";
        })
        .filter((item) => item);
      return contentItems.join("，");
    },

    // 切换任务状态
    switchWorkState(item) {
      this.conditions.state = item.state;
      this.page.current = 1;
      this.fetchData();
    },

    // 搜索事件
    handleSearch() {
      this.page.current = 1;
      this.fetchData();
    },

    // 重置事件
    handleReset() {
      this.conditions = {
        state: "",
        communityId: "",
        deptId: "",
        createUserId: "",
        workName: "",
        staffName: "",
        wtIds: [],
        wtId: "",
        queryStartTime: "",
        queryEndTime: "",
        urgencyLevel: "",
      };
      this.creatorList = [];
      this.getDeptList();
      this.page.current = 1;
      this.fetchData();
    },

    // 新增工单
    handleAdd() {
      this.$router.push("/views/oa/addWork");
    },

    // 编辑工单
    handleEdit(row) {
      this.$router.push(`/views/oa/editWork?workId=${row.workId}`);
    },

    // 查看详情
    handleDetail(row) {
      this.$router.push(`/views/oa/workDetail?workId=${row.workId}`);
    },

    getUrgencyText(level) {
      const levelMap = {
        1001: "重点",
        1002: "紧急",
        1003: "普通",
      };
      return levelMap[level];
    },

    getUrgencyTagType(level) {
      const typeMap = {
        1001: "danger",
        1002: "warning",
        1003: "success",
      };
      return typeMap[level] || "";
    },

    // 删除工单
    handleDelete(row) {
      this.$refs.deleteWork.open(row);
    },

    // 标记完成
    async handleComplete(row) {
      try {
        await this.$confirm(
          "确认要将该草稿工单标记为完成吗？标记后将无法再编辑为草稿！",
          "操作确认",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          },
        );

        const useCommunityId = this.conditions.communityId || this.communityId;
        await updateWorkState({
          workId: row.workId,
          state: "C",
          communityId: useCommunityId,
        });

        this.$message.success("工单标记为完成成功");
        this.fetchData();
      } catch (error) {
        if (error !== "cancel") {
          console.error("工单标记完成失败:", error);
          this.$message.error("工单标记完成失败");
        }
      }
    },

    // 分页大小变更
    handleSizeChange(size) {
      this.page.size = size;
      this.fetchData();
    },

    // 当前页码变更
    handlePageChange(current) {
      this.page.current = current;
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.start-work-container {
  padding: 15px;

  .state-sidebar {
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 0;
    height: 100%;

    .state-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .state-item {
        padding: 12px 15px;
        cursor: pointer;
        text-align: center;
        transition: all 0.3s;
        font-size: 14px;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active-state {
          background-color: #409eff;
          color: #fff;
        }
      }
    }
  }

  .search-card {
    margin-bottom: 15px;
    padding: 15px;

    .search-form {
      .el-form-item {
        margin-bottom: 0;
        label {
          font-size: 13px;
          font-weight: 500;
        }
      }
      .pt10 {
        padding-top: 10px;
      }
    }
  }

  .work-list-card {
    padding: 15px;

    .el-table {
      margin-top: 10px;
      font-size: 13px;

      .el-table-column {
        padding: 8px 0;
      }
      .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }
    }
  }

  .flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-end {
    justify-content: flex-end;
  }
}

/* 修复级联选择器弹窗样式 */
::v-deep .work-type-cascader {
  z-index: 9999 !important; /* 提高层级避免被遮挡 */
  width: 400px !important; /* 调整宽度 */

  .el-cascader-menu {
    height: auto !important;
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
